import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { BrandTab } from '@trinity/chat/types/entity-tabs';
import { useChatApiClient } from '../containers/Chat/useApiClient';
import { entityPageQueryKeys } from './useEntityPages';

/** The tabs chat-api says the caller may see on a brand, in order. */
export function useBrandTabs(brandId: number | null): UseQueryResult<BrandTab[]> {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: entityPageQueryKeys.tabs({ type: 'brand', id: brandId ?? 0 }),
    queryFn: async () => {
      if (brandId === null) {
        throw new Error('brandId is required to fetch brand tabs');
      }

      return apiClient.workspaceBrands.getBrandTabs(brandId);
    },
    enabled: brandId !== null,
  });
}
